module.exports = __webpack_public_path__ + "static/media/impressions.d46937ef.svg";